"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JoinWordsTogether = exports.GetStaffPlansToDiscuss = exports.GetSeparator = exports.GetOptionalAddons = exports.AddOnsForMention = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _staffAddOnDetailsMap = require("./addons/staffAddOnDetailsMap");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var GetSeparator = exports.GetSeparator = function GetSeparator(_ref) {
  var fullNumber = _ref.fullNumber,
    index = _ref.index,
    _ref$separator = _ref.separator,
    separator = _ref$separator === void 0 ? ', ' : _ref$separator,
    _ref$joiningWord = _ref.joiningWord,
    joiningWord = _ref$joiningWord === void 0 ? 'and ' : _ref$joiningWord,
    _ref$midSentence = _ref.midSentence,
    midSentence = _ref$midSentence === void 0 ? false : _ref$midSentence;
  if (index < fullNumber - 2) {
    return "".concat(separator, " ");
  }
  if (index === fullNumber - 2) {
    return "".concat(separator, " ").concat(joiningWord);
  }
  return midSentence ? '' : '.';
};
var joinHelpersPropTypes = {
  index: _propTypes["default"].number,
  separator: _propTypes["default"].string,
  joiningWord: _propTypes["default"].string,
  midSentence: _propTypes["default"].bool
};
GetSeparator.propTypes = _objectSpread({
  fullNumber: _propTypes["default"].number
}, joinHelpersPropTypes);
var JoinWordsTogether = exports.JoinWordsTogether = function JoinWordsTogether(_ref2) {
  var wordsArray = _ref2.wordsArray,
    _ref2$joiningWord = _ref2.joiningWord,
    joiningWord = _ref2$joiningWord === void 0 ? ' and ' : _ref2$joiningWord,
    _ref2$separator = _ref2.separator,
    separator = _ref2$separator === void 0 ? ',' : _ref2$separator,
    _ref2$midSentence = _ref2.midSentence,
    midSentence = _ref2$midSentence === void 0 ? false : _ref2$midSentence;
  return wordsArray.map(function (word, index) {
    return "".concat(word).concat(GetSeparator({
      index: index,
      joiningWord: joiningWord,
      fullNumber: wordsArray.length,
      midSentence: midSentence,
      separator: separator
    }));
  });
};
JoinWordsTogether.propTypes = joinHelpersPropTypes;
var GetStaffPlansToDiscuss = exports.GetStaffPlansToDiscuss = function GetStaffPlansToDiscuss(_ref3) {
  var visiblePlans = _ref3.visiblePlans,
    ProductGroupsKeyedByPlanNumber = _ref3.ProductGroupsKeyedByPlanNumber,
    hasActiveProductGroup = _ref3.hasActiveProductGroup,
    activeProductGroup = _ref3.activeProductGroup;
  return Object.values(visiblePlans).filter(function (visiblePlan) {
    var planNumber = visiblePlan.planNumber;
    var productGroup = ProductGroupsKeyedByPlanNumber["Plan_".concat(planNumber)];
    if (hasActiveProductGroup && activeProductGroup.productsGroups.indexOf(productGroup) === -1) {
      return false;
    }
    return true;
  });
};
var GetOptionalAddons = exports.GetOptionalAddons = function GetOptionalAddons(_ref4) {
  var AddOnsMap = _ref4.AddOnsMap,
    AllPlans = _ref4.AllPlans,
    planNumber = _ref4.planNumber,
    addOns = _ref4.addOns;
  var maxAddOnLimits = {};
  var limitBreakdown = {};
  var waitingPeriods = {};
  var optionalAddOns = AddOnsMap[planNumber] ? _toConsumableArray(new Set(AddOnsMap[planNumber].reduce(function (acc, variantPlan) {
    variantPlan.addOns.forEach(function (variantAddOn) {
      if (addOns.indexOf(variantAddOn) === -1) {
        var variantPlanDefinition = AllPlans["Plan_".concat(variantPlan.planNumber)];
        var variantLimits = variantPlanDefinition.limits,
          itemisedWaitingPeriods = variantPlanDefinition.waitingPeriods.detailed.itemisedWaitingPeriods;
        var addOnDetails = _staffAddOnDetailsMap.StaffAddOnDetailsMap[variantAddOn];
        var limitKey = addOnDetails.limitKey,
          breakdownLimitKey = addOnDetails.breakdownLimitKey;
        var hasLimit = limitKey && variantLimits[limitKey];
        var hasBreakdownLimits = breakdownLimitKey && variantLimits[breakdownLimitKey];
        waitingPeriods = _objectSpread(_objectSpread({}, waitingPeriods), itemisedWaitingPeriods);
        if (hasLimit) {
          var limitAsFloat = Number(variantLimits[limitKey].replace(/[^0-9.-]+/g, ''));
          if (!maxAddOnLimits[variantAddOn]) {
            maxAddOnLimits[variantAddOn] = {
              valueAsFloat: limitAsFloat,
              formattedValue: variantLimits[limitKey]
            };
          } else if (maxAddOnLimits[variantAddOn].valueAsFloat < limitAsFloat) {
            maxAddOnLimits[variantAddOn] = {
              valueAsFloat: limitAsFloat,
              formattedValue: variantLimits[limitKey]
            };
          }
        }
        if (hasBreakdownLimits) {
          if (!limitBreakdown[variantAddOn]) {
            limitBreakdown[variantAddOn] = {
              breakdown: [],
              planNames: []
            };
          }
          limitBreakdown[variantAddOn].breakdown = variantLimits[breakdownLimitKey];
          limitBreakdown[variantAddOn].planNames.push(variantPlanDefinition.externalName);
        }
        acc.push(variantAddOn);
      }
    });
    return acc;
  }, []))) : [];
  return {
    optionalAddOns: optionalAddOns,
    limitBreakdown: limitBreakdown,
    maxAddOnLimits: maxAddOnLimits,
    waitingPeriods: waitingPeriods
  };
};
var AddOnsForMention = exports.AddOnsForMention = function AddOnsForMention() {
  var addOns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return addOns.filter(function (addOn) {
    return _staffAddOnDetailsMap.StaffAddOnDetailsMap[addOn];
  });
};